module.exports = __webpack_public_path__ + "img/downfilter.c7828b2b.svg";